import Guarantees from './views/depositCredit.c';
export default Guarantees;
